// customization:
// - removed link wrapping entire content
// - added customizable cta

import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import imageBlockSVG from '@plone/volto/components/manage/Blocks/Image/block-image.svg';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import cx from 'classnames';
import config from '@plone/volto/registry';
import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';

const messages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
});

const TeaserDefaultTemplate = (props) => {
  const { className, data, isEditMode, style } = props;
  const intl = useIntl();
  const href = data.href?.[0];
  const image = data.preview_image?.[0];
  const url = data.preview_image?.[0]?.['@id'];

  const hrefContentImageField = data.use_alternative_preview_image
    ? 'alternative_preview_image'
    : href?.image_field;

  const Image = config.getComponent('Image').component;
  const Container = config.getComponent('Container').component || 'div';
  return (
    <div className={cx('block teaser block-teaser', className)} style={style}>
      <>
        <Container className={cx('block-teaser-container')}>
          {!href && isEditMode && (
            <Message>
              <div className="teaser-item placeholder">
                <img src={imageBlockSVG} alt="" />
                <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
              </div>
            </Message>
          )}
          {href && (
            <div className="teaser-item default">
              {url && !image?.image_field ? (
                <div className="image-wrapper">
                  <Image src={url} alt="" loading="lazy" responsive={true} />
                </div>
              ) : (
                (href.hasPreviewImage || href.image_field || image) && (
                  <div className="image-wrapper">
                    <Image
                      item={data.overwrite ? image ?? href : href}
                      imageField={
                        data.overwrite
                          ? image?.image_field ?? hrefContentImageField
                          : hrefContentImageField
                      }
                      alt=""
                      loading="lazy"
                      responsive={true}
                    />
                  </div>
                )
              )}
              <div className="content">
                {data?.head_title && (
                  <div className="headline">{data.head_title}</div>
                )}
                <h2>{data?.title}</h2>
                {!data.hide_description && <p>{data?.description}</p>}

                {href && (
                  <CTA
                    href={
                      data.href
                        ? flattenToAppURL(data.href[0]['@id'])
                        : undefined
                    }
                    openLinkInNewTab={false}
                    onClick={(e) => {
                      if (isEditMode) {
                        e.preventDefault();
                      }
                    }}
                    ctaButtonStyle={data.ctaButtonStyle}
                    linkIcon={data.linkIcon}
                    cta_color={data.cta_color}
                  >
                    {data.linkTitle}
                  </CTA>
                )}
              </div>
            </div>
          )}
        </Container>
      </>
    </div>
  );
};

TeaserDefaultTemplate.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default TeaserDefaultTemplate;
